"use strict";
const SignalBase = require('./SignalBase.js');

function SUM(a, b) {
    return a+b;
}

function ArrayEquals(a1, a2) {
    return a1.length==a2.length && a1.every((v,i)=> v === a2[i]);
}

function bufferToArray(buffer) {
    //fix malformed signals from signaldb
    if(buffer && buffer.type && buffer.type == 'Buffer') return buffer.data;
    if(buffer instanceof Array && buffer.length == 1 && buffer[0].type && buffer[0].type == 'Buffer') return buffer[0].data;

    if(!(buffer instanceof Buffer)) return buffer;
    let result = [];
    for( let i = 0; i < buffer.length; i++) result.push(buffer[i]);
    return result;
}

const SOF_WORD = 'S';
const EOF_WORD = 'E';

class Signal extends SignalBase {
    constructor(opts) {
        super(opts);
        this._receiving = false;

        //TODO: validation? -> happens in node-homey-lib
        //TODO: (validate restriction) Packing requires 2 words
        //TODO: (validate restriction) toggleIndexes must be inside sof bounds
        //TODO: validate toggleSOF and AGC

        //TODO document TXonly signals
        //TODO document toggleSof
        //TODO document AGC

		this.canReceive = !opts.txOnly;

        this._agc = opts.agc || [];
        this._sof = opts.sof || [];
        this._toggleSof = opts.toggleSof;
        this._eof = opts.eof || [];
        this._words = opts.words || [];
        this._prefixData = bufferToArray(opts.prefixData || []);
        this._postfixData = bufferToArray(opts.postfixData || []);
        this._sensitivity = Math.min(0.5, opts.sensitivity || 0.3);
        this._minimalLength = opts.minimalLength || 1;
        this._maximalLength = opts.maximalLength || Infinity;
        this._cmds = opts.cmds || {};
        this._packing = opts.packing || false;
        this._interval = opts.interval || 10000;
        this._toggleBits = opts.toggleBits || [];

        this._current = [];
        this._currentScore = 0;
        this._currentLength = 0;
        this._last = [];
        this._txToggleState = false;

        if(this._sof && this._sof.length) {
            //also count the sof word
            this._minimalLength++;
            this._maximalLength++;
        }

        this._calculateMaxDataLength();

        //TODO: toggle bits
    }

    _calculateMaxDataLength() {
        const maxes = [];
        maxes.push(Math.max.apply(null, this._sof));
        if(this._toggleSof)
            maxes.push(Math.max.apply(null, this._toggleSof));
        maxes.push(Math.max.apply(null, this._eof));
        for(let word of this._words)
            maxes.push(Math.max.apply(null, word));
        const max = Math.max.apply(null, maxes);
        this._maxDataLength = max*(1+this._sensitivity);
    }

    static scoreMatch(data, ref, user, skip) {
        if(ref.length === 0) throw new Error("invalid_ref");
        let mismatch = 1;
        let j = 0, i;
        for(i = 0; i < ref.length && j < data.length; i++) {
            let sum = data[j];
            //Right-align the first interval of sof words
            if(user === SOF_WORD && i == 0 && j == 0 && data[0] >= ref[0] && data[0] >= 1500) sum = ref[0];
            let prev = Math.abs(sum-ref[i]);
            let curLength = 1;

            let next;
            while(data.length < j+curLength+2 && prev > (next = Math.abs(sum+data[j+curLength+1]+data[j+curLength+2]-ref[i]))) {
                sum += data[j+1] + data[j+2];
                curLength += 2;
                prev = next;
            }

            for(let p = 1; p + 1 < curLength; p++) {
                mismatch += data[j+p];
            }

            mismatch += Math.abs(ref[i]-sum);

            j += curLength;
        }

        //if(i < ref.length) mismatch += ref.slice(i).reduce(SUM, 0);

        let score = Math.min(mismatch/ref.reduce(SUM,1), 1);

        let result = {
            score: score,
            length: j,
            ref: ref,
            user: user,
            skip: 0,
            exthausted: i < ref.length,
        };
        //console.log('res', result, data.slice(0,j));
        return result;
    }

    _preProcessPayload(data) {
        return data.slice();
    }

    _generateChunks(data) {
        let res = [];
        while(data.length) {
            let idx = data.findIndex((el, i) => i%2 === 1 &&el > this._maxDataLength);
            if(idx === -1) {
                res.push(data);
                data = data.slice(0,0);
            } else {
                res.push(data.slice(0,idx+1));
                data = data.slice(idx+1);
            }
        }
        return res;
    }

    _processChunk(data, carry) {
        let result;
        let skip = 0;

        if(this._nextData) {
            data = Array.from(this._nextData).concat(Array.from(data));
            skip = this._nextData.skip;
            this._nextData = null;
            clearTimeout(this._resetTimeout);
        }

        while(data.length) {
            let match;
            if(this._receiving || !this._sof || this._sof.length === 0) {
                match = this._findWords(data, skip);
            } else {
                match = this._findSOF(data, skip);
            }
            //console.log(match, data.slice(0,match.length+4), carry);

            let valid = (match.score <= this._sensitivity);
            let terminate = false;

            if(carry && valid && match.exthausted) {
                //if(skip) data[0] = data[0]-skip;
                this._nextData = data;
                this._nextData.skip = match.skip;
                break;
            }

            if(this._receiving && (!valid || this._current.length == this._maximalLength) && this._current.length >= this._minimalLength && this._eof && this._eof.length > 0) {

                let eofmatch = this._findEOF(data, skip);

                if(eofmatch.score < this._sensitivity) {
                    match = eofmatch;
                    valid = true;
                    terminate = true;
                }
            }

            if((!this._eof || !this._eof.length) && this._current.length+1 == this._maximalLength ) {
                terminate = true;
            }
            if(valid) {
                skip = match.skip;
                let chunk = data.slice(0, match.length);
                data = data.slice(chunk.length);
                this._currentLength += chunk.reduce(SUM, 0) + skip;
                this._current.push(match.user);
                this._currentScore += match.score;

                //console.log('a', this._current.join(','), terminate, this._current.length)
                if(match.user === SOF_WORD) this._candidateToggle = match.toggle;
                if(!terminate) this._receiving = true;
            } else {
                if(this._receiving){
                    //console.log('a', this._current.join(','), terminate, this._current.length)
                    //console.log(match, data.slice(0,match.length+4), carry);
                }
                //skip = 0;
                
                if(!this._receiving) {
                    data = data.slice(2);
                }
                terminate = true;
            }

            if(terminate) {
                this._receiving = false;
                let payload = this._endPacket();
                if(payload && !result) result = payload;
                data = data.slice(data.length%2);
                //skip = 0;
            }
        }

        if(this._current.length > 0) {
            clearTimeout(this._resetTimeout);
            this._resetTimeout = setTimeout(() => {
                this._endPacket();
                this._nextData = null;
            }, 500);
        }

        return result;
    }

    rx(data) {
        data = this._preProcessPayload(data);
        data = this._generateChunks(data);
        data = data
            .map((chunk, i) => this._processChunk(chunk, i === data.length - 1))
            .filter(res => res !== undefined);
        return data[0];
    }

    _scoreMatch(data, ref, user, skip) {
        return Signal.scoreMatch(data, ref, user, skip);
    }

    _findWords(data, skip) {
        let best = null;
        if(this._words.length === 0) throw new Error("no_words_specified");
        this._words.forEach((word, i) => {
            let match = this._scoreMatch(data, word, i, skip);
            if(!best || best.score > match.score) best = match;
        });
        return best;
    }

    _findSOF(data, skip) {
        let result = this._scoreMatch(data, this._sof, SOF_WORD, skip, true);
        if(this._toggleSof && this._toggleSof.length > 0) {
            let sof2 = this._scoreMatch(data, this._toggleSof, SOF_WORD, skip, true);
            let toggleState = (result.score <= sof2.score);
            result = toggleState ? result : sof2;
            result.toggle = toggleState;
        }

        return result;
    }

    _findEOF(data, skip) {
        return this._scoreMatch(data, this._eof, EOF_WORD, skip);
    }

    _endPacket() {
        let candidate = this._current;
        let length = this._currentLength;
        let score = this._currentScore/candidate.length;
        this._current = []; //reset packet
        this._currentScore = 0;
        this._currentLength = 0;
        if(!candidate || candidate.length === 0) return; //no data

        if(this._eof.length > 0) {
            if(candidate[candidate.length - 1] != EOF_WORD) return;
            else candidate = candidate.slice(0, -1);
        }
        if(candidate.length < this._minimalLength) return;
        if(candidate.length > this._maximalLength) return;
        if(this._sof.length > 0) {
            if(candidate[0] != SOF_WORD) return;
            else candidate = candidate.slice(1);
        }
        return this._gotPayload(candidate, length, score);
    }

    _postProcessPayload(data) {
        if(this._packing) {
            let result = [];
            while(data.length > 0) {
                let chunk = data.slice(0,8);
                data = data.slice(chunk.length);
                result.push(chunk.reduce((res, next) => (res << 1) + next, 0));
            }
            data = result;
        }
        //TODO: check for toggleBits
        if(this._prefixData.length > 0 && !ArrayEquals(data.slice(0, this._prefixData.length), this._prefixData)) {
            data = [];
        }
        if(this._prefixData.length > 0 && data.length) {
            data = data.slice(this._prefixData.length);
        }
        if(this._postfixData.length > 0 && !ArrayEquals(data.slice(data.length-this._postfixData.length), this._postfixData)) {
            data = [];
        }
        if(this._postfixData.length > 0 && data.length) {
            data = data.slice(0, -1*this._postfixData.length);
        }
        return data; //can be overloaded
    }

    _debouncePayload(payload, length) {
        //TODO: maybe limit length?
        let dbc = this._last;
        dbc.push(payload);
        const timeout = 3*(length+this._interval)/1000;
        return setTimeout(() => {
            dbc.shift();
        }, timeout);
    }

    _gotPayload(payload, length, score) {
        payload = this._postProcessPayload(payload);
        if(payload.length < 1) return;

        if(this._toggleState !== this._candidateToggle) {
            this._toggleState = this._candidateToggle;
            this._last = [];
        }

        let first = !this._last.some(ArrayEquals.bind(null, payload));
        //console.log('payload', payload);

        this.emit('payload', payload, first, score);
        this._debouncePayload(payload, length);

        //check commands
        if(Object.keys(this._cmds).length > 0) {
            //TODO: check for toggleBits
            Object.keys(this._cmds).forEach((cmd) => {
                if(ArrayEquals(this._cmds[cmd], payload)) {
                    this.emit('cmd', cmd, first);
                    payload = cmd;
                }
            });
        }
        return payload;
    }

    tx(data, repetitions) {
        data = this._constructPayload(data);
        return this.txRaw(data, repetitions);
    }

    _constructPayload(data) {
        data = this._preProcessData(data);
        //construct payload and send
        let payload = this._agc.concat(this._txToggleState && this._toggleSof ? this._toggleSof : this._sof);
        this._txToggleState = !this._txToggleState;
        data.forEach((word) => {
            payload = payload.concat(this._words[word]);
        });
        payload = payload.concat(this._eof);
        return this._postProcessData(payload);
    }

    _preProcessData(data) {
        data = this._prefixData.concat(bufferToArray(data)).concat(this._postfixData);

        if(this._packing) {
            let result = [];
            data.forEach((packed) => {
                result = result.concat(('00000000'+Number(packed).toString(2)).slice(-8).split('').map(Number));
            });
            data = result;
        }

        //TX toggle support
        if(this._txToggleState) {
            this._toggleBits.forEach((bit) => {
                data[bit] = (data[bit]+1)%2;
            });
        }
        return data; //can be overloaded
    }

    _postProcessData(data) {
        return data;
    }

    cmd(id, repetitions) {
	if(!this._cmds[id]) {
        throw new Error('unknown_cmd');
    }
    return this.tx(this._cmds[id], repetitions);
    }

}


module.exports = Signal;
